<template>
  <div class="course-container">
    <headerPage></headerPage>

    <div class="course-tou">
      <!-- 页面标题区域 -->
      <div class="page-header">
        <div class="page-header2">
          <!-- 返回按钮 -->
          <el-page-header @back="goHome"  class="return-button"></el-page-header>
          <h2 class="page-title">我的班级</h2>
        </div>
        <div class="divider"></div>
      </div>
      <!-- 课程展示区域 -->
      <div class="course-list">
        <el-row :gutter="20" class="course-row" v-if="classList.length > 0">
          <el-col :xs="24" :sm="12" :md="8" :lg="6" v-for="(course, index) in classList" :key="index"
                  class="course-col">
            <el-card class="course-card" shadow="hover">
              <!-- 课程图片 -->
              <img :src="course.imageUrl" class="course-image" alt="课程图片" />

              <!-- 课程信息区域 -->
              <div class="course-info">
                <!-- 课程标题 -->
                <h3 class="course-title">{{ course.title }}</h3>

                <!-- 课程价格区域 -->
                <p class="course-price">价格：¥{{ course.price }}</p>

                <!-- 学习进度条区域 -->
                <div class="progress-container">
                  <span class="progress-label">学习进度：</span>
                  <el-progress :percentage="course.progress" :stroke-width="8"
                               :color="getProgressColor(course.progress)"
                               style="height: 8px; width: 70%;"></el-progress>
                </div>
              </div>

              <!-- 底部区域 -->
              <div class="bottom">
                <span class="course-time">{{ formatDate(course.createTime) }}</span>
                <el-button type="primary" size="mini" @click="viewDetail(course)">查看详情</el-button>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <el-empty v-else description="暂无数据" ></el-empty>
      </div>
    </div>
    <bottomPage></bottomPage>
  </div>
</template>
<script>
import headerPage from "@/components/header/header";
import bottomPage from "@/components/bottom/bottom";

import * as myClassApi from "@/api/myClass";

export default {
  components: {
    headerPage,
    bottomPage,
  },
  data() {
    return {
      classList: [], // 课程数据
      userId: null, // 用户ID
    };
  },
  created() {
    this.loadUserData(); // 加载用户数据
  },
  methods: {
    // 加载用户数据
    loadUserData() {
      // 通过 getters 获取用户信息
      this.userId = this.$store.getters.userId; // 获取用户ID
      this.classIds = this.$store.getters.classIds; // 获取班级ID列表
      this.courseIds = this.$store.getters.courseIds; // 获取课程ID列表

      if (this.userId) {
        this.getMyExercisesClass(); // 使用用户ID加载班级课程数据
      } else {
        console.error("用户信息未找到，请检查是否已登录");
      }
    },
    // 根据用户ID加载我的班级课程
    async getMyExercisesClass() {
      try {
        const response = await myClassApi.getMyExercisesClass(this.userId);
        console.log("获取到的课程数据:", response.data);
        if (response.data && response.data.length > 0) {
          this.classList = response.data.map((item) => ({
            id: item.id,
            classId: item.classId,
            title: item.className,
            price: item.price,
            imageUrl: item.classImg,
            progress: this.calculateProgress(item.completePercent),
            createTime: this.formatDate(item.updateTime),
          }));
        }
      } catch (error) {
        console.error("获取课程数据失败:", error);
      }
    },
    // 计算进度百分比 (completeTime 为0时显示0%)
    calculateProgress(completeTime) {
      return completeTime > 0 ? Math.min(100, completeTime / 100) : 0;
    },
    // 格式化时间戳 -> yyyy-MM-dd
    formatDate(timestamp) {
      if (!timestamp) return "";
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    // 跳转到详情页面
    viewDetail(selectedCourse) {
      this.$router.push({
        name: "myClassInfo",
        params: {
          classId: selectedCourse.id,
          className: selectedCourse.title,
          classImg: selectedCourse.imageUrl,
        },
      });
    },
    // 根据进度动态返回颜色
    getProgressColor(progress) {
      if (progress < 50) {
        return "#f56c6c"; // 低进度红色
      } else if (progress < 80) {
        return "#e6a23c"; // 中等进度橙色
      } else {
        return "#67c23a"; // 高进度绿色
      }
    },
    // 返回首页
    goHome() {
      this.$router.push('/');
    }

  },
};
</script>
<style scoped>
/* 页面容器样式 */
.course-container {
  background-color: #f5f5f5;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.course-tou{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding:0 200px;
  box-sizing: border-box;
  overflow: hidden;
  background-color: #ffffff;
}
/* 课程列表样式 */
.course-list {
  width: 100%;
  height: 100%;
  overflow-y:auto;
  margin: 20px auto;
}

/* 页头区域样式 */
.page-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.page-header2{
  display: flex;
  align-items: center;
}
.course-row{
  width: 100%;
}

/* 页标题样式 - 左对齐 */
.page-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  text-align: left;
}

/* 分割线样式 - 灰色铺满 */
.divider {
  width: 100%;
  height: 2px;
  background-color: #dcdfe6;
}

/* 课程卡片样式 */
.course-card {
  border-radius: 10px;
  overflow: hidden;
  transition: transform 0.3s;
}

/* 增加卡片的上下间距 */
.course-col {
  margin-bottom: 20px;
}

.course-card:hover {
  transform: translateY(-5px);
}

/* 课程图片样式 */
.course-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
}

/* 课程信息区域 */
.course-info {
  padding: 0 14px 14px 14px;
  background-color: #f9f9f9;
  border-top: 1px solid #ebeef5;
}

/* 课程标题 */
.course-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin: 5px 0 3px 0; /* 调整为2px，缩小间距 */
}

/* 课程价格样式 - 靠右对齐 */
.course-price {
  font-size: 16px;
  font-weight: bold;
  color: #ff5722;
  margin: 1px 0 10px 0;
  text-align: right;
}

/* 学习进度条容器 */
.progress-container {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.progress-label {
  font-size: 14px;
  color: #333;
  margin-right: 10px;
  white-space: nowrap;
}

.el-progress {
  display: flex;
  align-items: center;
  width: 100%; /* 确保进度条占满剩余空间 */
}

.el-progress__text {
  margin-left: 10px; /* 调整文本与进度条之间的间距 */
  font-size: 14px; /* 确保文本字体大小与标签一致 */
  color: #333; /* 确保文本颜色与标签一致 */
}

/* 底部区域样式 */
.bottom {
  padding: 10px 14px;
  border-top: 1px solid #ebeef5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fafafa;
}

/* 课程时间 */
.course-time {
  font-size: 12px;
  color: #999;
}
</style>
